import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=4b476b2c&scoped=true"
import script from "./step2.vue?vue&type=script&lang=js"
export * from "./step2.vue?vue&type=script&lang=js"
import style0 from "./step2.vue?vue&type=style&index=0&id=4b476b2c&prod&scoped=true&lang=css"
import style1 from "./step2.vue?vue&type=style&index=1&id=4b476b2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_abc276eb37b0b1314bfe9ec856cc5e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b476b2c",
  null
  
)

export default component.exports